var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Nav',{attrs:{"id":"nav"}}),_c('modal',{attrs:{"name":"modal","height":"auto","width":"700px","scrollable":true,"adaptive":true,"clickToClose":false,"focusTrap":true}},[[_c('EForm')]],2),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }